import gql from 'graphql-tag'

export default gql`
  query listSubscriptions {
    listSubscriptions {
      email
      createdAt
      updatedAt
      payerUser {
        id
        email
        firstname
        lastname
        stripeCustomerId
      }
    }
  }
`
